import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {MasterDataLayoutService} from './services/master-data-layout.service';
import {ClientSearchComponent} from './components/client-search/client-search.component';
import {ClientGridRendererComponent} from './components/client-grid-renderer/client-grid-renderer.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    ClientSearchComponent,
    ClientGridRendererComponent
  ],
  exports: [
    ClientSearchComponent,
    ClientGridRendererComponent
  ],
  providers: [
    MasterDataLayoutService
  ]
})
export class MasterDataModule {
}
